import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsCountertopOptions = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.countertop.options;

export const options = setCalculationModeAdminSettingsCountertopOptions(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_COUNTERTOP_OPTIONS',
  []
);
